/**
 * Reasons that can fire the logout actions.
 */
export const REJECTION_REASONS = ['token_not_provided', 'token_expired', 'token_absent', 'token_invalid'];
